import { ICatalogue } from "../../apis/useGetCatalogueData/types";

export const checkCartHasItem = (item: ICatalogue, cart: ICatalogue[]): number => {
	const getItemStrWithoutQuantity = (item: ICatalogue) => {
		const { quantity, ...others } = item;

		return JSON.stringify(sortObjectKeys(others));
	};
	const targetItem = getItemStrWithoutQuantity(item);

	return cart.findIndex((cartItem) => {
		const cartItemWithoutQuantity = getItemStrWithoutQuantity(cartItem);

		return cartItemWithoutQuantity === targetItem;
	});
};

const sortObjectKeys = <T>(obj: T): T => {
	if (obj === null || typeof obj !== "object") {
		return obj;
	}
	if (Array.isArray(obj)) {
		return obj.map(sortObjectKeys) as T;
	}
	const sortedKeys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
	const sortedObj: Partial<T> = {};

	for (const key of sortedKeys) {
		sortedObj[key as keyof T] = sortObjectKeys(obj[key as keyof T]);
	}

	return sortedObj as T;
};
